import api from "./api";
import type {
  CreateUserInput,
  LoginInput,
  AuthTokens,
  UserResponse,
} from "@clawplete/shared/types";

export const authService = {
  async register(data: CreateUserInput, captchaToken?: string) {
    const response = await api.post<{ success: boolean; data: UserResponse }>("/auth/register", {
      ...data,
      captcha_token: captchaToken,
    });
    return response.data.data;
  },

  async login(data: LoginInput, captchaToken?: string) {
    const response = await api.post<{ success: boolean; data: UserResponse }>("/auth/login", {
      ...data,
      captcha_token: captchaToken,
    });
    return response.data.data;
  },

  async refreshToken(refreshToken: string) {
    const response = await api.post<{ success: boolean; data: UserResponse }>("/auth/refresh", {
      refresh_token: refreshToken,
    });
    return response.data.data;
  },

  async logout(refreshToken: string) {
    const response = await api.post<{ success: boolean; data: unknown }>("/auth/logout", {
      refresh_token: refreshToken,
    });
    return response.data.data;
  },

  async verifyEmail(token: string) {
    const response = await api.post<{ success: boolean; data: unknown }>("/auth/verify-email", { token });
    return response.data.data;
  },

  async forgotPassword(email: string) {
    const response = await api.post<{ success: boolean; data: unknown }>("/auth/forgot-password", { email });
    return response.data.data;
  },

  async resetPassword(token: string, newPassword: string) {
    const response = await api.post<{ success: boolean; data: unknown }>("/auth/reset-password", {
      token,
      new_password: newPassword,
    });
    return response.data.data;
  },
};
